module.exports = __webpack_public_path__ + "static/oncitybooks-d04caced5a1d2c468c7739e5dcb53697.png";